import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule } from '@angular/forms';
import { NgxEchartsModule } from 'ngx-echarts';
import { RouterLink } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NumberUtil } from '../../infra/number-util';
import { DateUtil } from '../../infra/date-util';

import { HomeComponent } from './home/home.component';
import { SegmentacaoComponent } from './segmentacao/segmentacao.component';
import { ListasComponent } from './listas/listas/listas.component';
import { ContatosComponent } from './listas/contatos/contatos.component';
import { FiltroPesquisavelComponent } from './segmentacao/filtro-pesquisavel/filtro-pesquisavel.component';
import { FiltroCheckboxComponent } from './segmentacao/filtro-checkbox/filtro-checkbox.component';
import { areaLogadaRoutes } from './area-logada.routes';
import { ExibirSegmentacaoComponent } from './segmentacao/exibir-segmentacao/exibir-segmentacao.component';
import { CarregandoComponent } from './shared/carregando/carregando.component';
import { ToastrModule } from 'ngx-toastr';
import { ModalListaContatoComponent } from './segmentacao/modal-lista-contato/modal-lista-contato.component';
import { ModalRecargaComponent } from './shared/modal-recarga/modal-recarga.component';
import { ModalContatoComponent } from './listas/contatos/modal-contato/modal-contato.component';
import { ListaUsuariosComponent } from './administrativo/usuarios/lista-usuarios/lista-usuarios.component';
import { ModalRenovarSessaoComponent } from './shared/renovar-sessao/modal-renovar-sessao.component';
import { TemPermissaoDirective } from '../../directives/tem-permissao.directive';
import { ModalGestaoAcessosComponent } from './administrativo/usuarios/modal-gestao-acessos/modal-gestao-acessos.component';
import { ModalUsuarioComponent } from './administrativo/usuarios/modal-usuario/modal-usuario.component';
import { ReactiveFormsModule } from '@angular/forms'
import { ModalSemCreditosComponent } from './shared/modal-sem-creditos/modal-sem-creditos.component';
import { ModalBoasVindasComponent } from './shared/modal-boas-vindas/modal-boas-vindas.component';
import { MeusDadosComponent } from './administrativo/meus-dados/meus-dados.component';

@NgModule({
  declarations: [
    HomeComponent,
    SegmentacaoComponent,
    ListasComponent,
    ContatosComponent,
    FiltroPesquisavelComponent,
    FiltroCheckboxComponent,
    ExibirSegmentacaoComponent,
    CarregandoComponent,
    ModalListaContatoComponent,
    ModalRecargaComponent,
    ModalContatoComponent,
    ListaUsuariosComponent,
    ModalRenovarSessaoComponent,
    TemPermissaoDirective,
    ModalGestaoAcessosComponent,
    ModalUsuarioComponent,
    ModalSemCreditosComponent,
    ModalBoasVindasComponent,
    MeusDadosComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(areaLogadaRoutes),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    RouterLink,
    NgSelectModule,
    NumberUtil,
    DateUtil,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    TemPermissaoDirective
    ]
  })
export class AreaLogadaModule { }
